module.exports = __webpack_public_path__ + "static/media/Puntos.00781602.svg";